function SchemaOrg() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "SaaS ForceKeys Services",
    url: siteUrl,
    logo: "https://public.readdy.ai/ai/img_res/3ef87599-1241-4809-b65e-3d0fc5310a8f.png",
    description:
      "SaaS ForceKeys Services builds powerful SaaS applications including Translate Cloud API, a unified translation API.",
    sameAs: ["https://support.saas.forcekeys.com"],
    contactPoint: {
      "@type": "ContactPoint",
      url: "https://support.saas.forcekeys.com",
      contactType: "customer support",
    },
  };

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Translate Cloud API",
    applicationCategory: "DeveloperApplication",
    operatingSystem: "Cloud",
    description:
      "Unified translation API connecting Google Translate, Azure Translator, AWS Translate, DeepL and ForceKeys Cloud with document translation, OCR and batch processing support.",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "150",
    },
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "SaaS ForceKeys Services - SaaS Development & Translation Cloud API",
    url: `${siteUrl}/`,
    description:
      "SaaS ForceKeys Services builds powerful SaaS applications. Translate Cloud API is a unified translation API connecting Google, Azure, AWS, DeepL and ForceKeys Cloud with document translation, OCR and batch processing support.",
    publisher: {
      "@type": "Organization",
      name: "SaaS ForceKeys Services",
      url: siteUrl,
    },
    dateModified: "2026-05-01",
  };

  const schemas = [organizationSchema, softwareSchema, webpageSchema];

  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      ))}
    </>
  );
}

export default SchemaOrg;